import { render, staticRenderFns } from "./MonthlyLoanCollectionReport.vue?vue&type=template&id=0f76a54e"
import script from "./MonthlyLoanCollectionReport.vue?vue&type=script&lang=js"
export * from "./MonthlyLoanCollectionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports